import BaseEvent from "./BaseEvent";
export default class HoldEndEvent extends BaseEvent {
    constructor(index) {
        super();
        this.PRIORITY = 3;
        this.INDEX = index;
    }
}
